export default "/build/images/elichens-logo-600px.7e351057.png";